import React from 'react';
import { ILegalTransactionGwGFullObject } from '../../../Interfaces/ILegalTransactionGwG';
import { ILegalPhaseFullObject } from '../../../Interfaces/ILegalPhase';
import { Box, Grid, Typography } from '@mui/material';
import { GwGElement } from './GwGElement';

interface IProps {
  gwgArray: ILegalTransactionGwGFullObject[];
  setGwgArray: Function;
  legalPhaseFullObjectArray: ILegalPhaseFullObject[];
}

export const GwGMain = ({
  gwgArray,
  setGwgArray,
  legalPhaseFullObjectArray,
}: IProps) => {
  return (
    <Grid container spacing={2}>
      <Grid item sm={12}>
        <Typography variant='h5' sx={{ mt: 3 }}>
          GwG
        </Typography>
      </Grid>
      <Grid item sm={12}>
        {gwgArray.map((gwgObject, idx) => (
          <>
            {idx !== 0 && <Box sx={{ mt: 10 }} />}
            <GwGElement
              key={`gwg-${gwgObject.idLegalTransactionGwG}`}
              gwgObject={gwgObject}
              gwgArray={gwgArray}
              setGwgArray={setGwgArray}
              legalPhaseFullObjectArray={legalPhaseFullObjectArray}
            />
          </>
        ))}
      </Grid>
    </Grid>
  );
};
